<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
  <div class="fill-files" [ngClass]="{'invalid-field': !valid && fieldSubmission.field.mandatory }">
    <core-storage-files-upload 
      (response)='onFilesChange($event)'
      (onUploading)="uploading = $event">
    </core-storage-files-upload>
  </div>
  <div *ngIf="initialFiles">
    <core-storage-file-uploaded-list-item 
        *ngFor="let iFile of initialFiles"
        [download]="true"
        [remove]="true" 
        (onRemove)="remove(iFile)" 
        [file]="iFile"
    ></core-storage-file-uploaded-list-item>

  </div>
</div>